import React from 'react';
import { Typography, TypographyType, TypographyVariant } from 'src/components-dummy';
import { BlastRadiusBannerProps } from './types';
import './BlastRadiusBanner.scss';

// TODO: the "est. X% of monthly impressions" figure is a demo placeholder - the prototype's own
const ESTIMATED_IMPRESSIONS_SHARE = '61%';

export const BlastRadiusBanner = ({
  changeCount,
  scopeLabel,
}: BlastRadiusBannerProps): JSX.Element => (
  <div className='syte-blast-radius-banner'>
    <Typography type={TypographyType.Body} variant={TypographyVariant.MediumBold}>
      {`Blast radius: ${changeCount} changes`}
    </Typography>
    <Typography type={TypographyType.Body} variant={TypographyVariant.SmallRegular}>
      {`With more than one change you'll see whether B won, but not why. Affects ${scopeLabel} · est. ${ESTIMATED_IMPRESSIONS_SHARE} of monthly impressions. Split this into two experiments unless the changes only make sense together.`}
    </Typography>
  </div>
);
